<template>
  <div v-if="!isAma" :class="[theme === 1 ? '' : 'theme-2']">
    <div class="row">
      <!-- Shipping type -->

      <div class="col-12 mb-3" v-if="isGioielleriaItalianaB2B &&
        fastDeliveryItems.length > 0
      ">
        <div class="option-label row" style="border-left: none !important">
          <div class="col-10 pl-0">
            <p class="text-left mb-0 pl-5 text-uppercase label-menu d-flex">
              {{ $t("fastDelivery") }}
              <img class="d-inline-block fast-delivery-img"
                src="https://content-test.gioielleriaitaliana.com/cr/configuratore/icons/fast_delivery.png" />
            </p>
          </div>
          <div class="col-2 text-right">
            <input type="checkbox" class="" v-model="fastDelivery" @change="fastDeliverySelection()" />
          </div>
        </div>

        <div class="w-100 pt-2 pl-3 fast-delivery-div" v-if="fastDelivery">

          <div v-for="option in fastDeliveryItems" class="row fast-delivery-option"
            :class="{ 'selected': selectedFastDeliveryItem == option }">
            <div class="col-xl-5 col-12">
              <img height="100" :src="baseImageUrl + option.images[0]" />
            </div>
            <div class="col-xl-7 col-12">
              <div v-for="(opt, index) in option.k" :key="opt">
                <b>{{
                  $t(
                    "option_" +
                    currentJewelSelection.options[index].type
                  )
                }}:</b>
                {{
                  getOptionValueLabel(
                    currentJewelSelection.options[index].values,
                    opt,
                    option.k[currentJewelSelection.options.findIndex(o => o.type == "gold")]
                  )
                }}
              </div>
              <div class="mt-2 red">
                <span v-if="option.availability == 1">{{ option.availability }}
                  {{ $t("pieceAvailable") }}</span>
                <span v-if="option.availability > 1">{{ option.availability }}
                  {{ $t("piecesAvailable") }}</span>
              </div>
            </div>
            <div class="col-xl-12 col-12 fast-delivery-selection-btn">
              <button class="btn w-100"
                @click="selectedFastDeliveryItem = option; fastDeliverySelectionItem(selectedFastDeliveryItem)">
                <span v-if="selectedFastDeliveryItem == option">{{ $t("selected") }}</span>
                <span v-else>{{ $t("select") }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div v-if="!fastDelivery" class="w-100">
        <!-- Stone Colors -->
        <div v-if="valueObj.values.length > 1" class="col-12 mb-3" v-for="valueObj in stoneColorObj" :key="valueObj.id">
          <div>
            <div class="option-label row" style="border-left: none !important">
              <div class="option-label-title">
                <span class="text-left mb-0 pl-5 text-uppercase label-menu">{{
                  $t("stoneColor")
                }}</span>
              </div>
              <div class="option-label-info">
                <v-popover :popoverClass="'tooltip-custom'" :placement="'top'">
                  <!-- Popover target -->
                  <font-awesome-icon class="info-button cursor-pointer" :icon="['fas', 'info-circle']" />
                  <!-- Content of popover -->
                  <template slot="popover">
                    <JewelDescriptionTooltip :data="valueObj.values" :type="'stone'"></JewelDescriptionTooltip>
                  </template>
                </v-popover>
              </div>
            </div>
            <div class="w-100 row pt-2 pl-5">
              <div v-for="stone in valueObj.values" :key="stone.id">
                <img :src="baseImageUrl + stone.image" height="40" width="40" class="rounded-circle cursor-pointer"
                  v-on:click="triggerToChange(stone.id, 'stone', valueObj.type)" :style="{
                    border:
                      selectedStoneObj[valueObj.type] == stone.id
                        ? '1px solid'
                        : '',
                    opacity: stone.disabled ? '0.2' : '1',
                  }" :class="{ disableImg: stone.disabled }" v-tooltip.top="{
                    content: stone.label,
                    trigger: 'hover click focus',
                    delay: { show: '200', hide: '500' },
                  }" />
              </div>
            </div>
          </div>
        </div>

        <!-- Stone sizes -->
        <div v-if="objSize.values.length > 1" class="col-12 mb-3" v-for="(objSize, key) in stoneSizeObj"
          :key="objSize.id">
          <div class="option-label row border-left-0">
            <div class="option-label-title">
              <p class="text-left mb-0 pl-5 text-uppercase label-menu">
                {{ $t("measureChoice") }}
              </p>
            </div>
            <div class="option-label-info" style="z-index: 999">
              <v-popover class="d-inline-block" :popoverClass="'tooltip-custom d-inline-block'" :placement="'top'">
                <!-- Popover target -->
                <font-awesome-icon class="info-button cursor-pointer" :icon="['fas', 'info-circle']" />
                <!-- Content of popover -->
                <template slot="popover">
                  <JewelDescriptionTooltip :description="$t('tooltipMeasureChoice')"></JewelDescriptionTooltip>
                </template>
              </v-popover>
            </div>
          </div>
          <div class="row pt-3 pl-5">
            <select class="w-100 select-setting" @change="
              triggerToChange($event.target.value, 'size', objSize.type)
              " :value="selectedStoneSizeObj[objSize.type]">
              <option :value="null"></option>
              <option v-for="size in objSize.values" :key="size.id" :value="size.id" :disabled="size.disabled">
                {{ size.label }} {{ objSize.sizeUnit === 'MM' ? 'mm' : 'ct' }}
              </option>
            </select>
            <CaratsTable v-if="objSize.type == 0 && credential.isBO" :selectObj="selectObj" />
          </div>
        </div>

        <!-- Golds -->
        <div class="col-12 mb-3" v-if="golds && golds.length > 0">
          <div>
            <div class="option-label row" style="border-left: none !important">
              <div>
                <p class="text-left pl-5 text-uppercase label-menu">
                  {{ $t("goldColor") }}
                </p>
              </div>
            </div>
            <div class="w-100 row pt-2 pl-5">
              <div v-for="gold in golds" :key="gold.id">
                <img class="rounded-circle mr-2 cursor-pointer" :src="baseImageUrl + gold.image" alt height="35"
                  width="35" v-on:click="triggerToChange(gold.id, '0')"
                  :style="{ border: selectedGold == gold.id ? '2px solid' : '', 'opacity': gold.disabled ? '0.2' : '1' }"
                  :class="{ 'disableImg': gold.disabled }" />
                <!-- :style="{'border': selectedGold == gold.id ? '2px solid' : '', 'opacity' : gold.disabled ? '0.2' : '1'}" -->
              </div>
            </div>
          </div>
        </div>

        <!-- Gold Karats -->
        <div class="col-12 mb-3" v-if="goldKarats && goldKarats.length > 0">
          <div class="option-label row border-left-0">
            <div class="col-8 pl-0">
              <p class="text-left pl-5 text-uppercase label-menu">
                {{ $t("goldKarat") }}
              </p>
            </div>
            <div class="col-4 pl-0">
              <select class="w-100 select-setting" @change="triggerToChange($event.target.value, 'goldKarat')"
                :value="selectedGoldKarat">
                <option :value="null"></option>
                <option v-for="karat in goldKarats" :key="karat.id" :value="karat.id" :disabled="karat.disabled">
                  {{ karat.label }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <!-- Sizes -->
        <div class="col-12 mb-3" v-if="sizes && sizes.length > 0">
          <div class="option-label row border-left-0">
            <div class="col-8 pl-0">
              <p class="text-left pl-5 text-uppercase label-menu">
                {{ $t(`measure${this.currentJewelSelection.categoryId}`) }}
              </p>
            </div>
            <div class="col-4 pl-0">
              <select class="w-100 select-setting" @change="triggerToChange($event.target.value, '1')"
                :value="selectedSize">
                <option :value="null"></option>
                <option v-for="size in sizes" :key="size.id" :value="size.id" :disabled="size.disabled">
                  {{ size.label }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <!-- Backings -->
        <div class="col-12 mb-3" v-if="backings && backings.length > 0">
          <div>
            <div class="option-label row border-left-0">
              <div class="option-label-title">
                <p class="text-left pl-5 text-uppercase label-menu">
                  {{ $t("backing") }}
                </p>
              </div>
              <div class="option-label-info">
                <v-popover class="d-inline-block" :popoverClass="'tooltip-custom d-inline-block'" :placement="'top'">
                  <!-- Popover target -->
                  <font-awesome-icon class="info-button cursor-pointer" :icon="['fas', 'info-circle']" />
                  <!-- Content of popover -->
                  <template slot="popover">
                    <JewelDescriptionTooltip :data="backings" :type="'backing'"></JewelDescriptionTooltip>
                  </template>
                </v-popover>
              </div>
            </div>
            <div class="w-100">
              <div v-for="backing in backings" :key="backing.id">
                <div class="row pt-2 pl-5">
                  <img class="rounded-circle mr-2 backing-img" :src="baseImageUrl + backing.image" alt height="50"
                    width="50" v-on:click="triggerToChange(backing.id, '2')"
                    :class="{ disableImg: backing.disabled }" />
                  <p class="backing-label pl-2 cursor-pointer mt-2" v-on:click="triggerToChange(backing.id, '2')"
                    :class="{
                      'backing-label-selected': checkSelectionOption(
                        backing.id,
                        'backing'
                      ),
                      disableImg: backing.disabled,
                    }">
                    {{ backing.label }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Chains -->
        <div class="col-12 mb-3" v-if="chains && chains.length > 0">
          <div>
            <div class="option-label row" style="border-left: none !important">
              <div class="option-label-title">
                <p class="text-left pl-5 text-uppercase label-menu">
                  {{ $t("chain") }}
                </p>
              </div>
              <div class="option-label-info">
                <v-popover class="d-inline-block" :popoverClass="'tooltip-custom d-inline-block'" :placement="'top'">
                  <!-- Popover target -->
                  <font-awesome-icon class="info-button cursor-pointer" :icon="['fas', 'info-circle']" />
                  <!-- Content of popover -->
                  <template slot="popover">
                    <JewelDescriptionTooltip :data="chains" :type="'chain'"></JewelDescriptionTooltip>
                  </template>
                </v-popover>
              </div>
            </div>
            <div class="w-100 pl-5">
              <div v-for="chain in chains" :key="chain.id">
                <div class="row pt-2">
                  <img class="rounded-circle mr-2 backing-img" :src="baseImageUrl + chain.image" alt height="50"
                    width="50" v-on:click="triggerToChange(chain.id, '4')" :class="{ disableImg: chain.disabled }" />
                  <p class="backing-label cursor-pointer mt-2" v-on:click="
                    !chain.disabled ? triggerToChange(chain.id, '4') : null
                    " :class="{
                      'backing-label-selected': checkSelectionOption(
                        chain.id,
                        'chain'
                      ),
                      disableImg: chain.disabled,
                    }">
                    {{ chain.label }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Letters -->
        <div class="col-12 mb-3" v-if="letters && letters.length > 0">
          <div class="option-label row" style="border-left: none !important">
            <div class="col-9 pl-0">
              <p class="text-left mb-0 pl-5 text-uppercase label-menu">
                {{ $t("letters") }}
              </p>
            </div>
            <div class="col-3 pl-0">
              <select class="row w-100 select-setting" @change="triggerToChange($event.target.value, '13')"
                :value="selectedLetter">
                <option v-for="letter in letters" :key="letter.id" :value="letter.id" :disabled="letter.disabled">
                  {{ letter.label }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="w-100">

          <!-- Logo -->
          <div class="col-12 mb-3" v-if="isLogoVisible">
            <div style="border-left: none !important">
              <div class="option-label row pl-0 position-relative">
                <div class="option-label-title">
                  <p class="text-left mb-0 pl-5 text-uppercase label-menu d-flex">
                    {{ $t("engraveYourLogo") }}
                  </p>
                </div>
                <div class="option-label-info">
                  <v-popover class="d-inline-block" :popoverClass="'tooltip-custom d-inline-block'" :placement="'top'">
                    <!-- Popover target -->
                    <font-awesome-icon class="info-button cursor-pointer" :icon="['fas', 'info-circle']" />
                    <!-- Content of popover -->
                    <template slot="popover">
                      <JewelDescriptionTooltip :description="$t('tooltipEngraveYourLogo')"></JewelDescriptionTooltip>
                    </template>
                  </v-popover>
                </div>
              </div>
              <div class="row">
                <div class="col-10 pl-0">
                  <label class="text-left pl-5 incisione-label" v-if="currentJewelSelection &&
                    currentJewelSelection.logoPrice &&
                    retailPerc === 1
                  ">
                    {{ $t("addLogo") }} +
                    {{
                      currentJewelSelection.logoPrice.toFixed(2).replace(".", ",")
                    }}€
                  </label>
                </div>
                <div class="col-2 text-right">
                  <input class="incisione-checkbox" type="checkbox" v-model="logo" :disabled="!jewelDescription
                    " @click="logoSelection($event.target.checked)" />
                </div>
              </div>
            </div>
          </div>

          <!-- Engrave -->

          <div class="col-12 mb-3" v-if="isEngraveVisible">
            <div>
              <div class="option-label row" style="border-left: none !important">
                <div class="option-label-title">
                  <p class="text-left mb-0 pl-5 text-uppercase label-menu d-flex">
                    {{ $t("customizeEngraving") }}
                  </p>
                </div>
                <div class="option-label-info">
                  <v-popover class="d-inline-block" :popoverClass="'tooltip-custom d-inline-block'" :placement="'top'">
                    <!-- Popover target -->
                    <font-awesome-icon class="info-button cursor-pointer" :icon="['fas', 'info-circle']" />
                    <!-- Content of popover -->
                    <template slot="popover">
                      <JewelDescriptionTooltip :description="$t('tooltipCustomizeEngraving')">
                      </JewelDescriptionTooltip>
                    </template>
                  </v-popover>
                </div>
              </div>
              <div class="row">
                <div class="col-10 pl-0">
                  <label class="text-left pl-5 incisione-label" v-if="currentJewelSelection &&
                    currentJewelSelection.writingPrice &&
                    retailPerc === 1
                  ">
                    {{ $t("addEngraving") }} +
                    {{
                      currentJewelSelection.writingPrice
                        .toFixed(2)
                        .replace(".", ",")
                    }}€
                  </label>
                </div>
                <div class="col-2 text-right">
                  <input class="incisione-checkbox" type="checkbox" :disabled="!jewelDescription
                    " v-model="incisione" @click="incisioneSelection($event.target.checked)" />
                </div>
              </div>

              <div class="row pt-2 pl-5">
                <input type="text" class="w-100 input-incisione" :style="{
                  border: incisione && !incisioneLabel ? '1px solid red' : '',
                }" :placeholder="$t(`max10Char`, {
                  char: currentCategory ? currentCategory.maxChars || 10 : 10,
                })
                  " :disabled="!incisione" v-model="incisioneLabel" :maxlength="currentCategory ? currentCategory.maxChars || 10 : 10"
                  v-on:input="incisioneSelectionLabel()" />
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 mb-3" v-if="isRhodiumTypeVisible">
          <div class="option-label row" style="border-left: none !important">
            <div class="col-6 pl-5">
              <p class="text-left pl-0 text-uppercase label-menu">
                {{ $t("bluing") }}
              </p>
            </div>

          </div>
          <div class="row pt-3 pl-5">
            <select class="w-100 select-setting" @change="selectionBrunitura($event.target.value)"
              :value="selectedBluing" style="width: inherit">
              <option value="RHODIUM_NORMAL" selected="selected">
                {{ $t("rhodium") }}
              </option>
              <option value="TIPS_BLUING">{{ $t("tipsBluing") }}</option>
              <option value="RHODIUM_BLACK">{{ $t("rhodiumBlack") }}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="isWarrantyVisible && isGioielleriaItalianaB2B">
        <div class="option-label row" style="border-left: none !important">
          <div class="pl-5">
            <p class="text-left pl-0 text-uppercase label-menu">
              {{ $t("printWarranty") }}
            </p>
          </div>
        </div>
        <div class="row pt-3 pl-5">
          <p class="mb-0 warranties-description">{{ $t("warrantyDescription") }}<a class="warranty-mail"
              href="mailto:ivana@gioielleriaitaliana.com">ivana@gioielleriaitaliana.com</a></p>
        </div>
      </div>
      <!--
      <div class="col-12 mb-3" v-if="isWarrantyVisible">
        <div  class="option-label row" style="border-left: none !important">
          <div class="col-10 pl-0 d-inline-block position-relative">
            <p class="text-left mb-0 pl-5 text-uppercase label-menu d-flex">
              {{ $t("printWarranty") }}

              <v-popover class="d-inline-block" :popoverClass="'tooltip-custom d-inline-block'" :placement="'top'">
      <font-awesome-icon class="info-button cursor-pointer" :icon="['fas', 'info-circle']" />
      <template slot="popover">
        <JewelDescriptionTooltip :description="$t('tooltipWarranty')"></JewelDescriptionTooltip>
      </template>
      </v-popover>
      </p>
      <p class="text-left pl-5 incisione-label" v-if="
        currentJewelSelection &&
        currentJewelSelection.warrantyPrice &&
        retailPerc === 1
      ">
        ( {{ $t("addWarranty") }} +
        {{
        currentJewelSelection.warrantyPrice.toFixed(2).replace(".", ",")
        }}€)
      </p>
    </div>
    <div class="col-2 pl-0">
      <input type="checkbox" class="w-100 pt-1 checkbox- d-flex" v-model="warranty" :disabled="
        !jewelDescription
      " @click="warrantySelection($event.target.checked)" />
    </div>
  </div>
  </div>
  -->
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapMutations, mapState } from "vuex";

import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import JewelDescriptionTooltip from "./JewelDescriptionTooltip";
import "vue-directive-tooltip/dist/vueDirectiveTooltip.css";

import VueTippy, { TippyComponent } from "vue-tippy";

Vue.use(VueTippy);
// or
Vue.use(VueTippy, {
  directive: "tippy", // => v-tippy
  flipDuration: 0,
  popperOptions: {
    modifiers: {
      preventOverflow: {
        enabled: false,
      },
    },
  },
});

Vue.component("tippy", TippyComponent);

import "swiper/swiper-bundle.css";
import CaratsTable from "./CaratsTable.vue";

export default {
  name: "RingSettings",
  components: {
    JewelDescriptionTooltip,
    CaratsTable
  },
  data: function () {
    return {
      retailPerc: 1,
      vat: 1,
      baseImageUrl: process.env.VUE_APP_IMAGE_PATH,
      selectedSize: "null",
      selectedStoneSize: "null",
      selectedBacking: "null",
      selectedGold: "null",
      selectedGoldKarat: "null",
      selectedLetter: "null",
      selectedChain: "null",
      selectedShape: null,
      skuSelected: "",
      selectedBluing: "RHODIUM_NORMAL",
      incisione: false,
      logo: false,
      warranty: false,
      incisioneLabel: null,
      selectObj: {},
      swiperOptionsStones: {
        slidesPerView: 10,
        spaceBetween: 10,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
      selectedFastDeliveryItem: null,
      selectingJewel: false,
      fastDelivery: false,
    };
  },
  directives: {
    swiper: directive,
  },
  computed: {
    keysList: function () {
      const kl = Object.assign({}, this.currentJewelSelection.keys);
      return Object.keys(kl).map((key, index) => {
        const k = key.split("|");
        const o = kl[key];
        o.k = k;
        return o;
      });
    },
    fastDeliveryItems: function () {
      return JSON.parse(
        JSON.stringify(
          this.keysList
            .filter((key) => key.availability > 0)
            .sort((a, b) => a.optionPrice[0].price - b.optionPrice[0].price)
        )
      );
    },
    getCategoryOptions: function () {
      return this.currentCategory && this.currentCategory.option ? this.currentCategory.option.split("_") : [];
    },
    isRhodiumTypeVisible: function () {
      return (
        this.currentJewelSelection.productType != "GOLDSMITH" &&
        this.getCategoryOptions.includes("RHODIUM")
      );
    },
    isLogoVisible: function () {
      return (
        this.isGioielleriaItalianaB2B &&
        this.currentJewelSelection.productType != "GOLDSMITH" &&
        this.jewelDescription &&
        this.getCategoryOptions.includes("LOGO")
      );
    },
    isEngraveVisible: function () {
      return (
        this.currentJewelSelection.productType != "GOLDSMITH" &&
        this.jewelDescription &&
        this.currentCategory &&
        this.getCategoryOptions.includes("WRITE")
      );
    },
    isWarrantyVisible: function () {
      return (
        this.jewelDescription &&
        this.currentCategory &&
        this.getCategoryOptions.includes("WARRANTY")
      );
    },
    ...mapState({
      credential: (state) => state.config.credential,
      // currentCategory: (state) => state.detail.currentCategory,
      currentCategory: (state) => {
        return state.detail.currentCategory;
      },
      theme: (state) => state.config.theme,
      selectedSku: (state) => state.detail.selectedSku,
      optionsMap: (state) => state.detail.optionsMap,
      optionsMapDefault: (state) => state.detail.optionsMapDefault,
      jewelDescription: (state) => state.detail.jewelDescription,
      currentJewelSelection: (state) => state.detail.currentJewelSelection,
      options: (state) => state.detail.currentJewelSelection.options,
      selectedStoneObj: (state) => state.detail.selectedStoneObj,
      searchJewel: (state) => state.list.searchJewel,
      selectedStoneSizeObj: (state) => state.detail.selectedStoneSizeObj,
      preselectedJewel: (state) => state.detail.preselectedJewel,
      preselectedLogo: (state) => state.detail.preselectedLogo,
      preselectedWarranty: (state) => true /*state.detail.preselectedWarranty*/,
      basePrice: (state) => state.detail.basePrice,
      isGioielleriaItalianaB2B: (state) => state.config.isGioielleriaItalianaB2B,
      isAma: (state) => state.config.isAma,
      buildYourJewelMode: (state) => state.buildYourJewel.buildYourJewelMode,
      backings: (state) =>
        state.detail.currentJewelSelection.options.find(
          (a) => a.type === "backing"
        )
          ? state.detail.currentJewelSelection.options.find(
            (a) => a.type === "backing"
          ).values
          : [],
      chains: (state) =>
        state.detail.currentJewelSelection.options.find(
          (a) => a.type === "chain"
        )
          ? state.detail.currentJewelSelection.options.find(
            (a) => a.type === "chain"
          ).values
          : [],
      sizes: (state) =>
        state.detail.currentJewelSelection.options.find(
          (a) => a.type === "size"
        )
          ? state.detail.currentJewelSelection.options.find(
            (a) => a.type === "size"
          ).values
          : [],
      stoneSizes: (state) =>
        state.detail.currentJewelSelection.options.find(
          (a) => a.type === "stoneSize"
        )
          ? state.detail.currentJewelSelection.options.find(
            (a) => a.type === "stoneSize"
          ).values
          : [],
      stoneColorObj: (state) => state.detail.stoneColorObj,
      stoneSizeObj: (state) => state.detail.stoneSizeObj,
      stoneShape: (state) => state.detail.currentJewelSelection.options.find((a) => a.type === "stoneShape")?.values,
      golds: (state) =>
        state.detail.currentJewelSelection.options.find(
          (a) => a.type === "gold"
        )
          ? state.detail.currentJewelSelection.options.find(
            (a) => a.type === "gold"
          ).values
          : [],
      goldKarats: (state) =>
        state.detail.currentJewelSelection.options.find(
          (a) => a.type === "goldKarat"
        )
          ? state.detail.currentJewelSelection.options.find(
            (a) => a.type === "goldKarat"
          ).values
          : [],
      letters: (state) =>
        state.detail.currentJewelSelection.options.find(
          (a) => a.type === "letter"
        )
          ? state.detail.currentJewelSelection.options.find(
            (a) => a.type === "letter"
          ).values
          : [],
    }),
  },
  mounted() {
    this.retailPerc = this.$store.state.detail.retailPerc;
    this.vat = this.$store.state.detail.vat;

    var goldSetted;
    let cheapestJewel;

    if (this.$route.query.fastDelivery) {
      this.fastDelivery = true;
      this.fastDeliverySelection();
      if (this.isWarrantyVisible && this.preselectedWarranty) {
        this.warranty = true;
        this.warrantySelection(this.warranty);
      }
    } else if (!this.$route.params.direct) {
      let selectionJewel = [];

      if (Object.keys(this.keysList).length === 1) {
        cheapestJewel = this.keysList[0];
        this.triggerToChange(cheapestJewel.k[0], 0);
      } else {
        this.options.forEach((option, index) => {
          if (option.type === "gold" && this.searchJewel.goldColorId) {
            selectionJewel[index] = this.searchJewel.goldColorId.toString();
          }
          /*if (
            option.type === "stoneShape" &&
            option.stoneNumber === 0
          ) {
            selectionJewel[index] = option.values[0].id;
          }*/
          if (
            option.type === "stoneColor" &&
            option.stoneNumber === 0 &&
            this.searchJewel.stoneColor &&
            option.values.some((a) => a.id === this.searchJewel.stoneColor)
          ) {
            selectionJewel[index] = this.searchJewel.stoneColor;
          }
          if (option.type === "backing" || option.type === "chain") {
            if (
              option.values.find(
                (val) =>
                  this.optionsMapDefault[option.type] &&
                  this.optionsMapDefault[option.type].includes(
                    val.id.replace("{gt}", goldSetted)
                  )
              )
            ) {
              selectionJewel[index] = option.values.find(
                (val) =>
                  this.optionsMapDefault[option.type] &&
                  this.optionsMapDefault[option.type].includes(
                    val.id.replace("{gt}", goldSetted)
                  )
              ).id;
            }
          }

          if (
            ((option.type === "gold" && !this.searchJewel.goldColorId) ||
              option.type !== "gold") &&
            this.optionsMapDefault[
            `${option.type}${this.currentJewelSelection.categoryId}`
            ] &&
            option.values.some((val) =>
              this.optionsMapDefault[
                `${option.type}${this.currentJewelSelection.categoryId}`
              ].includes(val.id)
            )
          ) {
            selectionJewel[index] = option.values.find((a) =>
              this.optionsMapDefault[
                `${option.type}${this.currentJewelSelection.categoryId}`
              ].includes(a.id)
            ).id;
          }
        });

        for (const key in this.keysList) {
          if (Object.hasOwnProperty.call(this.keysList, key)) {
            const element = this.keysList[key];

            if (Object.keys(selectionJewel).every((index) => element.k[index] == selectionJewel[index])) {
              if (cheapestJewel) {
                if (
                  element.optionPrice[0].price <
                  cheapestJewel.optionPrice[0].price
                ) {
                  cheapestJewel = element;
                }
              } else {
                cheapestJewel = element;
              }
            }
          }
        }
      }
    } else {
      if (
        this.preselectedJewel.sku.substr(
          this.preselectedJewel.sku.length - 3
        ) === "-wa"
      ) {
        this.warranty = true;
        this.preselectedJewel.sku = this.preselectedJewel.sku.slice(0, -3);
        setTimeout(() => {
          this.warrantySelection(this.warranty);
        }, 500);
      }
      if (
        this.preselectedJewel.sku.substr(
          this.preselectedJewel.sku.length - 2
        ) === "-w"
      ) {
        this.incisione = true;
        this.incisioneLabel = this.preselectedJewel.writing;
        this.preselectedJewel.sku = this.preselectedJewel.sku.slice(0, -2);
        setTimeout(() => {
          this.incisioneSelection(this.incisione);
          this.incisioneSelectionLabel();
        }, 500);
      }
      if (
        this.preselectedJewel.sku.substr(
          this.preselectedJewel.sku.length - 2
        ) === "-l"
      ) {
        this.logo = true;
        setTimeout(() => {
          this.logoSelection(this.logo);
        }, 500);
        this.preselectedJewel.sku = this.preselectedJewel.sku.slice(0, -2);
      }

      if (
        this.preselectedJewel.sku.substr(
          this.preselectedJewel.sku.length - 3
        ) === "-rb" ||
        this.preselectedJewel.sku.substr(
          this.preselectedJewel.sku.length - 3
        ) === "-tb"
      ) {
        if (
          this.preselectedJewel.sku.substr(
            this.preselectedJewel.sku.length - 3
          ) === "-rb"
        ) {
          this.selectedBluing = "RHODIUM_BLACK";
          setTimeout(() => {
            this.selectionBrunitura(this.selectedBluing);
          }, 500);
        }
        if (
          this.preselectedJewel.sku.substr(
            this.preselectedJewel.sku.length - 3
          ) === "-tb"
        ) {
          this.selectedBluing = "TIPS_BLUING";
          setTimeout(() => {
            this.selectionBrunitura(this.selectedBluing);
          }, 500);
        }
        this.preselectedJewel.sku = this.preselectedJewel.sku.slice(0, -3);
      }

      if (
        this.preselectedJewel.sku.substr(
          this.preselectedJewel.sku.length - 3
        ) === "-pc"
      ) {
        this.preselectedJewel.sku = this.preselectedJewel.sku.slice(0, -3);
        this.fastDelivery = true;
        this.selectedFastDeliveryItem = this.fastDeliveryItems.find(
          (item) => (item.sku = this.preselectedJewel.sku)
        );
        this.selectedSku = this.selectedFastDeliveryItem.sku;
        this.fastDeliverySelection();
        return;
      }

      if (
        Object.keys(this.keysList).length === 1 &&
        Object.keys(this.keysList)[0] === ""
      ) {
        cheapestJewel = this.keysList[""];
        this.triggerToChange(cheapestJewel.k[0], 0);
      } else {
        for (const key in this.keysList) {
          if (Object.hasOwnProperty.call(this.keysList, key)) {
            const element = this.keysList[key];
            if (element.sku == this.preselectedJewel.sku) {
              cheapestJewel = element;
            }
          }
        }
      }
    }

    if (!this.$route.query.fastDelivery) {
      this.selectingJewel = true;
      this.selectJewel(cheapestJewel.k);
      this.selectingJewel = false;

      if (!this.$route.params.direct) {
        if (this.isLogoVisible && this.preselectedLogo) {
          this.logo = true;
          this.logoSelectionConfirmed(this.logo);
        }
        if (this.isWarrantyVisible && this.preselectedWarranty) {
          this.warranty = true;
          this.warrantySelection(this.warranty);
        }
      }
    }

    Vue.setHeight();
    this.scrollTo();
  },
  methods: {
    ...mapMutations("detail", [
      "setValueAndChangeRing",
      "changePrice",
      "addValueToJewel",
      "setSelectedStoneObj",
      "resetSelectedStoneObj",
      "setSelectedStoneSizeObj",
      "setLogoWriting",
      "setStateGold",
    ]),
    addToBasket() {
      this.$parent.addToBasket();
    },
    //check if the selected backing/chaing overlapping the placeholder is selected
    checkSelectionOption(id, type) {
      if (type === "backing") {
        return id.replace("{gt}", this.selectedGold) === this.selectedBacking;
      }
      if (type === "chain") {
        return id.replace("{gt}", this.selectedGold) === this.selectedChain;
      }
    },

    logoSelection(value) {
      if (!this.selectingJewel && this.fastDelivery) {
        this.showFastDeliveryConfirmModal().then((res) => {
          if (res) {
            this.fastDelivery = false;
            this.fastDeliverySelection();
            this.logoSelectionConfirmed(value);
          } else this.logo = !value;
        });
      } else this.logoSelectionConfirmed(value);
    },

    logoSelectionConfirmed(value) {
      this.logo = value;
      const price = value
        ? this.currentJewelSelection.logoPrice
        : -this.currentJewelSelection.logoPrice;

      this.setLogoWriting({ label: "logo", value: value });
      this.selectObj.logo = value;
      this.addValueToJewel({
        category: "optionsJewel",
        value: {
          selectObj: this.selectObj,
        },
      });
      this.changePrice(price);
    },
    incisioneSelection(value) {
      if (!this.selectingJewel && this.fastDelivery) {
        this.showFastDeliveryConfirmModal().then((res) => {
          if (res) {
            this.fastDelivery = false;
            this.fastDeliverySelection();
            this.incisioneSelectionConfirmed(value);
          } else this.incisione = !value;
        });
      } else this.incisioneSelectionConfirmed(value);
    },
    incisioneSelectionConfirmed(value) {
      this.incisione = value;
      const price = value
        ? this.currentJewelSelection.writingPrice
        : -this.currentJewelSelection.writingPrice;
      this.changePrice(price);
      if (!value) {
        this.setLogoWriting({ label: "writing", value: null });
        this.selectObj.writing = null;
        this.addValueToJewel({
          category: "optionsJewel",
          value: {
            selectObj: this.selectObj,
          },
        });
      } else {
        this.incisioneSelectionLabel();
      }
    },

    // sanitize input/paste to ASCII-only and enforce max length
    sanitizeIncisione(text) {
      const max = this.currentCategory ? this.currentCategory.maxChars || 10 : 10;
      if (!text) return "";
      let sanitized = String(text).replace(/[^\x00-\x7F]/g, "");
      if (sanitized.length > max) sanitized = sanitized.slice(0, max);
      return sanitized;
    },

    incisioneSelectionLabel() {
      const sanitized = this.sanitizeIncisione(this.incisioneLabel || "");
      if (sanitized !== this.incisioneLabel) {
        this.incisioneLabel = sanitized;
      }
      this.setLogoWriting({ label: "writing", value: this.incisioneLabel });
      this.selectObj.writing = this.incisioneLabel;
      this.addValueToJewel({
        category: "optionsJewel",
        value: {
          selectObj: this.selectObj,
        },
      });
    },
    warrantySelection(value) {
      this.warranty = value;
      const price = value
        ? this.currentJewelSelection.warrantyPrice
        : -this.currentJewelSelection.warrantyPrice;

      this.setLogoWriting({ label: "warranty", value: value });
      this.changePrice(price);
    },
    selectionBrunitura(value) {
      if (!this.selectingJewel && this.fastDelivery) {
        this.showFastDeliveryConfirmModal().then((res) => {
          if (res) {
            this.fastDelivery = false;
            this.fastDeliverySelection();
            this.selectionBrunituraConfirmed(value);
          }
        });
      } else this.selectionBrunituraConfirmed(value);
    },

    selectionBrunituraConfirmed(value) {
      this.selectedBluing = value;
      this.setLogoWriting({ label: "rhodiumType", value: this.selectedBluing });
      this.selectObj.rhodiumType = this.selectedBluing;
      this.addValueToJewel({
        category: "optionsJewel",
        value: {
          selectObj: this.selectObj,
        },
      });
    },

    getValueForSku(type, number) {
      if (type === "stoneColor") {
        return this.selectObj[`stoneColor${number}`] || null;
      } else if (type === "stoneSize") {
        return this.selectObj[`stoneSize${number}`] || null;
      } else {
        return this.selectObj[type];
      }
    },
    scrollTo() {
      window.parent.postMessage(
        {
          func: "setGioielleriaItalianaScroll",
          message: 0,
        },
        "*"
      );
    },
    goldSelection(value) {
      this.selectedGold = value;
      this.setStateGold(value);
      if (this.backings && this.backings.length > 0) {
        this.triggerToChange(this.selectedBacking.replace(/.$/, "{gt}"), "2");
      } else if (this.chains && this.chains.length > 0) {
        this.triggerToChange(this.selectedChain.replace(/.$/, "{gt}"), "4");
      }
    },

    //this method compose the selected sku and then make a research for all the available combinations
    triggerToChange(value, type, optType) {
      if (!this.selectingJewel && this.fastDelivery) {
        this.showFastDeliveryConfirmModal().then((res) => {
          if (res) {
            this.fastDelivery = false;
            this.fastDeliverySelection();
            this.triggerToChangeConfirmed(value, type, optType);
          }
        });
      } else this.triggerToChangeConfirmed(value, type, optType);
    },
    //this method compose the selected sku and then make a research for all the available combinations
    triggerToChangeConfirmed(value, type, optType) {
      this.$emit("changeSettings");
      if (type === "stone" && optType == null) {
        for (const key in this.stoneColorObj) {
          if (this.stoneColorObj.hasOwnProperty(key)) {
            this.stoneColorObj[key].values.forEach((st) => {
              if (st.id === value) {
                optType = this.stoneColorObj[key].type;
              }
            });
          }
        }
      }

      this.skuSelected = "";
      switch (type) {
        case "stoneShape":
          this.selectedShape = value;
          break;
        case "stone":
          this.setSelectedStoneObj({
            type: optType,
            value: this.selectedStoneObj[optType] === value ? "null" : value,
          });
          break;
        case "size":
          this.setSelectedStoneSizeObj({
            type: optType,
            value: (this.selectedStoneSizeObj[optType] = value),
          });
          break;
        case "goldKarat":
          this.selectedGoldKarat = value;
          break;
        case "0":
          this.goldSelection(value);
          break;
        case "1":
          this.selectedSize = value;
          break;
        case "3":
          this.selectedStoneSize = value;
          break;
        case "2":
          this.selectedBacking =
            this.selectedBacking === value
              ? "null"
              : this.selectedGold
                ? value.replace("{gt}", this.selectedGold)
                : value;
          break;
        case "13":
          this.selectedLetter = this.selectedLetter = value;
          break;
        case "4":
          this.selectedChain =
            this.selectedChain === value
              ? "null"
              : this.selectedGold
                ? value.replace("{gt}", this.selectedGold)
                : value;
          break;
        default:
          break;
      }

      if (this.golds.length > 0) {
        this.selectObj.gold = this.selectedGold;
      }
      if (this.options.some((o) => o.type === "goldKarat")) {
        this.selectObj.goldKarat = this.selectedGoldKarat;
      }
      if (this.backings.length > 0) {
        this.selectObj.backing = this.selectedBacking;
      }
      if (this.chains.length > 0) {
        this.selectObj.chain = this.selectedChain;
      }
      if (this.sizes.length > 0) {
        this.selectObj.size = this.selectedSize;
      }
      if (this.stoneShape?.length > 0) {
        this.selectObj.stoneShape = this.selectedShape;
      }

      if (this.stoneColorObj && Object.keys(this.stoneColorObj).length > 0) {
        for (const key in this.selectedStoneObj) {
          if (this.selectedStoneObj.hasOwnProperty(key)) {
            this.selectObj[`stoneColor${key}`] = this.selectedStoneObj[key];
          }
        }
      }

      if (this.stoneSizeObj && Object.keys(this.stoneSizeObj).length > 0) {
        for (const key in this.selectedStoneSizeObj) {
          if (this.selectedStoneSizeObj.hasOwnProperty(key)) {
            this.selectObj[`stoneSize${key}`] = this.selectedStoneSizeObj[key];
          }
        }
      }

      if (this.letters.length > 0) {
        this.selectObj.letter = this.selectedLetter;
      }

      this.skuSelected = "";
      this.options.forEach((element) => {
        this.skuSelected === ""
          ? (this.skuSelected = `${this.skuSelected}${this.getValueForSku(
            element.type,
            element.stoneNumber
          )}`)
          : (this.skuSelected = `${this.skuSelected}|${this.getValueForSku(
            element.type,
            element.stoneNumber
          )}`);
      });
      this.setValueAndChangeRing({
        sku: this.skuSelected,
      });

      this.addValueToJewel({
        category: "optionsJewel",
        value: {
          selectObj: this.selectObj,
        },
      });
    },
    selectJewel(choices) {
      this.options.forEach((option, idx) => {
        if (option.type === "gold") {
          this.triggerToChange(choices[idx], "0");
        }
        if (option.type === "size") {
          this.triggerToChange(choices[idx], "1");
        }
        if (option.type === "backing") {
          this.triggerToChange(choices[idx], "2");
        }
        if (option.type === "chain") {
          this.triggerToChange(choices[idx], "4");
        }
        if (option.type === "letter") {
          this.triggerToChange(choices[idx], "13");
        }
        if (option.type === "goldKarat") {
          this.triggerToChange(choices[idx], "goldKarat");
        }
        if (option.type === "stoneShape") {
          this.triggerToChange(choices[idx], "stoneShape", option.stoneNumber);
        }
        if (option.type === "stoneColor") {
          this.triggerToChange(choices[idx], "stone", option.stoneNumber);
        }
        if (option.type === "stoneSize") {
          this.triggerToChange(choices[idx], "size", option.stoneNumber);
        }
      });
    },
    fastDeliverySelection() {
      this.$emit("changeFastDelivery", this.fastDelivery);
      this.setLogoWriting({ label: "fastDelivery", value: this.fastDelivery });
      if (this.fastDelivery) {
        this.fastDeliverySelectionItem(
          this.fastDeliveryItems.find((item) => item.sku == this.selectedSku) ||
          this.fastDeliveryItems[0]
        );
      } else {
        this.selectedFastDeliveryItem = null;
        this.changePrice(
          this.basePrice -
          this.basePrice * this.currentJewelSelection.fastDeliveryMargin
        );
      }
    },
    fastDeliverySelectionItem(item) {
      if (!!this.selectedFastDeliveryItem) {
        this.changePrice(
          this.basePrice -
          this.basePrice * this.currentJewelSelection.fastDeliveryMargin
        );
      }
      this.selectingJewel = true;
      this.selectedFastDeliveryItem = item;
      this.resetSelectedStoneObj();
      this.selectedBacking = "null";
      this.selectedChain = "null";
      this.selectedBluing = "RHODIUM_NORMAL";
      this.logo && this.logoSelection(false);
      this.incisione && this.incisioneSelection(false);
      //this.warranty && this.warrantySelection(false);
      this.selectJewel(item.k);
      this.selectionBrunitura(this.selectedBluing);
      this.selectingJewel = false;
      this.changePrice(
        this.basePrice * this.currentJewelSelection.fastDeliveryMargin -
        this.basePrice
      );
    },
    getOptionValueLabel(values, key, goldType) {
      return values.find((value) => value.id.replace("{gt}", goldType) == key).label;
    },
    showFastDeliveryConfirmModal() {
      const h = this.$createElement;
      // Using HTML string
      const messageVNode = h("div", {
        domProps: {
          innerHTML:
            "<h6>" +
            this.$t("jewelConfigurationNotAvailable") +
            "</h6> " +
            this.$t("standardShippingConfirm"),
        },
      });

      return new Promise((resolve) => {
        this.scrollTo();
        this.$bvModal
          .msgBoxConfirm([messageVNode], {
            title: this.$t("fastDelivery"),
            buttonSize: "sm",
            okVariant: "primary",
            okTitle: this.$t("ok"),
            cancelTitle: this.$t("cancel"),
            headerClass: "header-fast-delivery-modal",
            bodyClass: "body-fast-delivery-modal",
            footerClass: "footer-fast-delivery-modal",
            hideHeaderClose: false,
          })
          .then((value) => {
            resolve(value);
          })
          .catch((err) => {
            resolve(false);
          });
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.theme-2 {

  span,
  p {
    color: var(--primary-color-1);
  }

  .choice-list,
  .btn-primary-2 {
    span {
      color: white !important;
    }
  }
}

div.option-label {
  border-bottom: 1px solid var(--secondary-color-1);
  padding: 5px 0px;
}

.option-label {}

.label-menu {
  text-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  font-size: 18px;
  font-weight: bold;
  color: var(--primary-color-1);
  margin: 0;

  .info-button {
    margin-left: 10px;
  }
}

.select-setting {
  border: 1px solid var(--primary-color-1);
  display: initial;
  border-radius: 9px;
  padding: 4px;
  cursor: pointer;
}

@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .label-menu {
    text-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
    font-size: 12px;
    font-weight: bold;
    color: var(--primary-color-1);
    margin: 0;
  }

  .select-setting {
    font-size: 14px;
  }

  .incisione-label {
    font-size: 12px !important;
  }

  .warranties-description {
    font-size: 12px !important;
  }

  .backing-label {
    border: 1px solid var(--primary-color-1);
    border-radius: 9px;
    padding: 5px 20px;
    font-size: 10px;
  }
}

.backing-label {
  border: 1px solid var(--primary-color-1);
  border-radius: 9px;
  padding: 5px 20px;
}

.backing-label:disabled {
  border: 1px solid var(--primary-color-1);
  border-radius: 9px;
  background-color: rgba(0, 0, 0, 0.16);
  padding: 5px 20px;
}

.backing-label-selected {
  background-color: var(--primary-color-1);
  color: #fff !important;
}

@media only screen and (max-width: 768px) {
  .label-menu {
    text-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
    font-size: 12px;
    font-weight: bold;
    color: var(--primary-color-1);
  }

  .select-setting {
    font-size: 14px;
  }

  .backing-label {
    border: 1px solid var(--primary-color-1);
    border-radius: 9px;
    padding: 5px 20px;
    font-size: 10px;
  }

  .incisione-label {
    font-size: 12px !important;
  }

  .warranties-description {
    font-size: 12px !important;
  }
}

.disableImg {
  pointer-events: none;
  cursor: default;
  background-color: rgba(0, 0, 0, 0.16);
}

.label-setting {
  font-size: 25px;
}

.input-incisione {
  border-radius: 9px;
  border: solid 1px #00254b;
  background-color: #ffffff;
}

.backing-img {
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
}

.incisione-label {
  font-size: 16px;
  margin: 0;
  margin-top: 5px;
}

.warranties-description {
  font-size: 14px;
}

.incisione-checkbox {
  margin-top: 8px;
}

[data-popover="stonesDescr"],
[data-popover="chainsDescr"],
[data-popover="backingsDescr"] {
  background: #fff;
  color: #000;
  font-size: 12px;
  height: 120px;
  line-height: 1.5;
}

.info-button-parent {
  position: absolute;
  /* right: 17px; */
  left: 90%;
  float: right;
}

.info-button {
  background-color: transparent !important;
  border: none;
}

.tippy-tooltip {
  background-color: #fff !important;
  box-shadow: 0 5px 30px rgba(black, 0.1) !important;
}

.fast-delivery-img {
  height: 22px;
  margin-left: 8px;
  margin-right: 10px;
}

.fast-delivery {
  background-color: var(--secondary-color-1);
}

.fast-delivery-option {
  color: var(--primary-color-1);
  padding: 5px 0px;
  font-size: 14px;
  border-bottom: 1px solid var(--primary-color-1);

  img {
    border-radius: 50%;
  }

  &.selected {
    background-color: var(--secondary-color-1);

    .fast-delivery-selection-btn {
      .btn {
        background-color: var(--secondary-color-1) !important;
        color: #fff !important;
        border: 1px solid;
      }
    }
  }
}

.red {
  color: red;
}

.fast-delivery-selection-btn {
  display: flex;
  align-items: center;

  .btn {
    background-color: #fff !important;
    text-transform: uppercase;
    padding: 2px 10px;
    margin: 10px;
    border: 1px solid;
  }
}

.fast-delivery-div {
  max-height: 530px;
  overflow-x: hidden;
  overflow-y: auto;
}

.option-label-title {
  display: table-cell;
  width: 90%;
}

.option-label-info {
  display: table-cell;
  width: 10%;
  padding-right: 15px;
  text-align: right;
}

.warranty-mail {
  color: var(--primary-color-1);
  text-decoration: none !important;
}
</style>
